import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analytics';

// Hook for tracking page views on route changes
export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        // Get page name from pathname
        const pageName = location.pathname === '/' ? 'home' : location.pathname.slice(1);

        // Track page view
        analyticsService.trackPageView(pageName);
    }, [location]);
};

// Hook for initializing analytics
export const useAnalytics = (userId = null) => {
    useEffect(() => {
        // Initialize analytics on mount
        analyticsService.initialize(userId);

        // Track session end on unmount
        return () => {
            analyticsService.trackSessionEnd();
        };
    }, [userId]);
};

export default analyticsService;
